import React from 'react'
import ResetPasswordComponent from './components/ResetPasswordComponent'

const ResetPassword: React.FC = () => {
  return <ResetPasswordComponent />
}

export default ResetPassword
